export const HealthcareTabletProgram = {
    FiggersHCT: 'Figgers',
    PalmBeachHCT: 'PalmBeach',
    FloridaConnect: 'FloridaConnect',
    PompanoBeach: 'PompanoBeach'
};

export const HealthcareTabletProgramApplyFor = {
    Self: 'Self',
    Beneficiary: 'Beneficiary',
};

export const HealthcareFloridaConnectApplyFor = {
    Self: 'Self',
    Other:'Other',
    AChild: 'A Child',
    AStudent: 'A Student',
    ARelative: 'A Relative',
};


